var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('v-row',{staticClass:"mt-0"},[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_vm._v("\n      Halaman About\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }